export enum AlertType {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
}

export enum AlertDismissAfter {
  Default = 5000,
  Short = 2000,
  Long = 10000,
}

export interface ShowAlert {
  id?: string;
  text: React.ReactNode;
  kind: AlertType;
  dismissAfter?: number;
  persistent?: boolean;
}
